import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CustomerService, TemplateService } from '../_services/index';
import { ParameterData } from '../_helpers/index';
import { NotificationTemplate } from '../_models/index';
import { notificationStatus, notificationType } from '../_enums/index';

import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
    selector: 'templates/edit',
    templateUrl: './templateedit.component.html',
    styleUrls: ['./templateedit.component.css']
})
export class TemplateEditComponent implements OnInit {
    tags: any[] = [];

    public notificationForm: FormGroup;
    public customer_public_id: string;
    public Template_Id: any;
    isalertVisiable = false;
    statusresult: any;
    ddlnotificationtype: any[];
    ddlnotificationStatus: any[];
    public buttonValidate = false;
    notificationType : any[];
    notificationTypeForWhatsapp : any [];
    isTypeWhatsapp = false;

    htmlEditorConfig: AngularEditorConfig = {
        editable: true,
        spellcheck: true,
        height: '25rem',
        minHeight: '5rem',
        placeholder: 'Texto aqui...',
        translate: 'no',
        enableToolbar: true,
        showToolbar: true,

        customClasses: [ // optional
            {
                name: "quote",
                class: "quote",
            },
            {
                name: 'redText',
                class: 'redText'
            },
            {
                name: "titleText",
                class: "titleText",
                tag: "h1",
            },
        ]
    };

    htmlEditorConfigForWhatsapp: AngularEditorConfig = {
        editable: false,
        spellcheck: true,
        height: '25rem',
        minHeight: '5rem',
        placeholder: 'Texto aqui...',
        translate: 'no',
        enableToolbar: false,
        showToolbar: false,

        customClasses: [ // optional
            {
                name: "quote",
                class: "quote",
            },
            {
                name: 'redText',
                class: 'redText'
            },
            {
                name: "titleText",
                class: "titleText",
                tag: "h1",
            },
        ]
    };

    constructor(
        private parameterData: ParameterData
        , private _fb: FormBuilder
        , private router: Router
        , private route: ActivatedRoute
        , private customerService: CustomerService
        , private _notificationType: notificationType
        , private _notificationStatus: notificationStatus
        , private templateService:TemplateService
        , private spinnerService: Ng4LoadingSpinnerService
    ) {
        this.isalertVisiable = false;
        this.ddlnotificationtype = _notificationType.dbtType;
        this.ddlnotificationStatus = _notificationStatus.Status;
        this.InitialSetup();
        
    }


    InitialSetup() {

        this.notificationForm = this._fb.group({
            id: new FormControl(0),
            name: new FormControl("", Validators.required),
            type: new FormControl("Email"),
            status: new FormControl("Activo"),
            header: new FormControl("", Validators.required),
            content: new FormControl("", Validators.required)
        });


    }

    ngOnInit() {
        this.getTagsApi();
        this.spinnerService.show();
        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            let browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');
            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
        }


        //used to retrieve the template id
        let params: any = this.route.snapshot.params;
        this.Template_Id = params.id;
        this.getTemplateType();
        if (this.Template_Id != null) {

            this.customerService.getIndNotificationTemplateDetail(this.Template_Id).subscribe((notification: NotificationTemplate) => {
                this.isTypeWhatsapp = notification.type == "WHATSAPP" ? true : false;
                if(this.isTypeWhatsapp == true){
                    this.notificationForm.disable();
                }
                setTimeout(() => {
                    this.spinnerService.hide();
                    this.notificationForm = this._fb.group({
                        id: new FormControl(notification.id),
                        name: new FormControl(notification.name, Validators.required),
                        type: new FormControl(notification.type),
                        status: new FormControl(notification.status),
                        header: new FormControl(notification.header, Validators.required),
                        content: new FormControl(notification.content, Validators.required)
                    });
                }, 500)
            })
        }





    } // end of ngonInit

    
    getTemplateType() {
        this.templateService.getTemplateType(this.customer_public_id).subscribe(result => {
            this.notificationType = result.values.channels.filter(item => item.active == true && item.id != 'WHATSAPP');
            this.notificationTypeForWhatsapp = result.values.channels.filter(item => item.active == true);
        },
        error => {
            console.error('Failed while trying getType.' + error)
        })
    }

    onsubmit({ value }: { value: NotificationTemplate }) {
        this.buttonValidate = true;

        this.customerService.updateNotificationTemplate(this.Template_Id, value)
            .subscribe((result) => {

                this.statusresult = "La información fue grabada correctamente !";
                this.isalertVisiable = true;

            }, error => {
                
                this.statusresult = error.error.Description;

                this.isalertVisiable = true;
                console.error('Failed while trying to update the Debtor Details.' + error);
            });

    }
    getTagsApi(){
        this.templateService.getTags().subscribe((data) => {
          this.tags=[
          {label: data[0].name, id: data[0].value},
          {label: data[1].name, id: data[1].value},
          {label: data[2].name, id: data[2].value},
          {label: data[3].name, id: data[3].value},
          {label: data[4].name, id: data[4].value},
          {label: data[5].name, id: data[5].value},
          {label: data[6].name, id: data[6].value},
          {label: data[7].name, id: data[7].value},
          {label: data[8].name, id: data[8].value},
          {label: data[9].name, id: data[9].value},
          {label: data[10].name, id: data[10].value},
          {label: data[11].name, id: data[11].value},
          {label: data[12].name, id: data[12].value},
          {label: data[13].name, id: data[13].value},
          {label: data[14].name, id: data[14].value},
          {label: data[15].name, id: data[15].value},
          {label: data[16].name, id: data[16].value},
          {label: data[17].name, id: data[17].value},
          {label: data[18].name, id: data[18].value},
          {label: data[19].name, id: data[19].value},
          {label: data[20].name, id: data[20].value},
          ]
          }, error => {        
            console.log('Failed while trying get Tags.' + error);
          });
    }
    
    onOptionSelected($event: Event): void {
        const value: any = $event;
        const value2:string= value
        var inputTemporal = document.createElement("textarea");
        inputTemporal.value = value2;
        document.body.appendChild(inputTemporal);
        inputTemporal.select();
        document.execCommand("copy");
        document.body.removeChild(inputTemporal);
    }
}

